import { createSlice } from "@reduxjs/toolkit";
import axios from "@utilities/api/httpService";
import { BASE_URL } from "../../routers/AppRoute";

export const initialState = {
  loading: false,
  hasErrors: false,
  getAllMenuFullData: [],
};

// A slice for recipes with our three reducers
const getAllMenuFullDataSlice = createSlice({
  name: "getAllMenuFullData",
  initialState,
  reducers: {
    getAllMenuFullData: (state) => {
      state.loading = true;
    },
    getAllMenuFullDataSuccess: (state, { payload }) => {
      state.getAllMenuFullData = payload;
      state.loading = false;
      state.hasErrors = false;
    },
    getAllMenuFullDataFailure: (state) => {
      state.loading = false;
      state.hasErrors = true;
    },
  },
});

// Three actions generated from the slice
export const { getAllMenuFullData, getAllMenuFullDataSuccess, getAllMenuFullDataFailure } =
  getAllMenuFullDataSlice.actions;

// A selector
export const getAllMenuFullDataSelector = (state: { getAllMenuFullData: any }) =>
  state.getAllMenuFullData;

// The reducer
export default getAllMenuFullDataSlice.reducer;

// Asynchronous thunk action
export function fetchgetAllMenuFullData() {
  return async (dispatch: any) => {
    dispatch(getAllMenuFullData());
    try {
      const URL = BASE_URL + `/GetAllMenu`;
      const response: any = await axios.get(URL);
      var jsonData = response.data;
      // console.log("jsonData .........", jsonData);
      dispatch(getAllMenuFullDataSuccess(jsonData));
      // debugger;
    } catch (error) {
      dispatch(getAllMenuFullDataFailure());
    }
  };
}

